import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import {
  contactDataByID,
} from "./contactsActions";
import { ErrorResponse } from "src/types/error-response.type";
import { ContactWithID } from '../../types/request.type';
import { initContactResponse } from "./createNewContactSlice";

type ContactRequestState = {
    contactRequest: ContactWithID;
    loading: boolean;
    success: boolean;
    error: string | null;
};

const initialState: ContactRequestState = {
  contactRequest: initContactResponse ,
    loading: false,
    success: false,
    error: ""
};

const contactRequestSliceID = createSlice({
  name: "contacts",
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры
    setContactsState(state, action: PayloadAction<ContactWithID>) {
       state.contactRequest = action.payload;
    },

    setContactState(state, action: PayloadAction<ContactWithID>) {
      state.contactRequest = action.payload;
    },


  },

  extraReducers: (builder) => {
    builder
     
      .addCase(contactDataByID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(contactDataByID.fulfilled, (state, action) => {
        state.loading = false;

        contactRequestSliceID.caseReducers.setContactState(state, action);
      })
      .addCase(contactDataByID.rejected, (state, action) => {
        state.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.error = errorText ? errorText : "";
      });
  },
});


const getErrorText = (error: ErrorResponse) => {
 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
};

export const contactRequestReducerID = contactRequestSliceID.reducer;